import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Content, SubContent, Main } from "../../../components/Layout";
import { Row, Col } from "react-bootstrap";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";
import { useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import useFormat from "../../../hooks/utils/useFormat";
import Button from "../../../components/Button";
import BudgetsList from "../../../components/BudgetsList";
import api from "../../../services/api";
import EmptyError from "../../../components/EmptyError";

export default function Draft() {
  const navigate = useNavigate();

  const { setbreadcrumb, config } = useWrapper();
  const { sortObject } = useFormat();

  const { commercial } = useOutletContext();
  const { commercialId } = useParams();

  const [isWaitingResponse, setisWaitingResponse] = useState(true);

  const [budgets, setbudgets] = useState([]);
  useEffect(() => {
    (async () => {
      if (!!commercial?.id) {
        try {
          const { data: _budgets } = await api.get(`budget-colection?commercial_id=${commercial?.id}`, config);

          sortObject({
            array: _budgets,
            key: "updated_at",
            type: "date",
          });
          sortObject({
            array: _budgets,
            key: "main",
            type: "boolean",
          });
          setbudgets(_budgets);
        } catch (__err) {
          console.log("__err", __err);
          toast.error("Problema ao carregar os orçamentos.");
        }

        setisWaitingResponse(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is a new object every WrapperProvider render (src/context/WrapperContext.jsx, outside this file's scope); adding it would refire this fetch on unrelated context updates. `sortObject` is a stable module-level function reference.
  }, [commercial?.id, sortObject]);

  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial, setbreadcrumb]);

  return (
    <>
      <Main>
        <Content noBG="true">
          <Row>
            <Col>
              <SubContent>
                <Row>
                  <Col sm={9}>
                    <h2 className="mini-title">Rascunhos de Orçamentos:</h2>
                    <p className="small-label mb-4">
                      Elabore modelos de orçamento para realizar simulações antes de alterar a planilha de custo
                    </p>
                  </Col>
                  <Col sm={3} className="text-end">
                    <Button
                      color="primary"
                      onClick={() => {
                        navigate(`/business/budget/${commercialId}/new`);
                      }}
                    >
                      Novo Rascunho
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {!isWaitingResponse ? (
                      <>
                        {budgets.length > 0 ? (
                          <BudgetsList budgets={budgets} />
                        ) : (
                          <EmptyError msg={<p>Nenhum orçamento cadastrado.</p>} />
                        )}
                      </>
                    ) : (
                      <Loading />
                    )}
                  </Col>
                </Row>
              </SubContent>
            </Col>
          </Row>
        </Content>
      </Main>
    </>
  );
}
